<template>
  <div>
    <h3>Attributes:</h3>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="value" label="参数" width="150"> </el-table-column>
      <el-table-column prop="describe" label="说明" width="150"> </el-table-column>
      <el-table-column prop="type" label="类型" width="200"> </el-table-column>
      <el-table-column prop="Option" label="可选值" width="150"> </el-table-column>
      <el-table-column prop="default" label="默认值" width="150"> </el-table-column>
      <el-table-column prop="required" label="必填" width="50"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          value: " color",
          describe: "图标颜色",
          type: "String/Object",
          Option: "-",
          default: JSON.stringify({
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "red"
              }
            ],
            global: false
          }),
          required: "true"
        },
        {
          value: " title",
          describe: "标题",
          type: "String",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " lineDirection",
          describe: "渐变方向",
          type: "String",
          Option: "x/y",
          default: "x",
          required: "false"
        },
        {
          value: " themeKey",
          describe: "主题色关键字",
          type: "String",
          Option: "bigScreen/portal",
          default: "bigScreen",
          required: "false"
        }
      ]
    }
  }
}
</script>

<style></style>
